export var MerchantOverrides = {
  BorderRadius: {
    ModalDefault: 4,
    PaginationDefault: 4
  },
  Colors: {
    BannerHighlightBackground: 'SystemBlue5',
    BannerHighlightIcon: 'SystemBlue70',
    ButtonFabBackground: 'SystemWhite',
    ButtonFabBackgroundDisabled: 'SystemGrey0',
    ButtonFabBackgroundHovered: 'SystemGrey0',
    ButtonFabBackgroundPressed: 'SystemGrey5',
    ButtonFabForeground: 'SystemBlack',
    ButtonFabForegroundDisabled: 'SystemGrey30',
    ButtonFlatPrimaryBackground: 'SystemWhite',
    ButtonFlatPrimaryBackgroundDisabled: 'SystemGrey0',
    ButtonFlatPrimaryBackgroundHovered: 'SystemGrey5',
    ButtonFlatPrimaryBackgroundPressed: 'SystemGrey5',
    ButtonFlatPrimaryForeground: 'SystemBlue60',
    ButtonFlatPrimaryForegroundDisabled: 'SystemGrey30',
    ButtonFlatSecondaryBackground: 'SystemWhite',
    ButtonFlatSecondaryBackgroundDisabled: 'SystemGrey0',
    ButtonFlatSecondaryBackgroundHovered: 'SystemGrey5',
    ButtonFlatSecondaryBackgroundPressed: 'SystemGrey5',
    ButtonFlatSecondaryForeground: 'SystemBlue60',
    ButtonFlatSecondaryForegroundDisabled: 'SystemGrey30',
    ButtonPrimaryBackground: 'SystemBlue60',
    ButtonPrimaryBackgroundDisabled: 'SystemGrey0',
    ButtonPrimaryBackgroundHovered: 'SystemBlue70',
    ButtonPrimaryBackgroundPressed: 'SystemBlue80',
    ButtonPrimaryForeground: 'SystemWhite',
    ButtonPrimaryForegroundDisabled: 'SystemGrey30',
    ButtonPrimaryToggleBackground: 'SystemBlue5',
    ButtonPrimaryToggleBackgroundHovered: 'SystemBlue10',
    ButtonPrimaryToggleBackgroundPressed: 'SystemBlue20',
    ButtonPrimaryToggleBackgroundDisabled: 'SystemBlue0',
    ButtonPrimaryToggleBorder: 'SystemBlue40',
    ButtonPrimaryToggleBorderHovered: 'SystemBlue40',
    ButtonPrimaryToggleBorderPressed: 'SystemBlue40',
    ButtonPrimaryToggleBorderDisabled: 'SystemBlue10',
    ButtonPrimaryToggleForeground: 'SystemBlue70',
    ButtonPrimaryToggleForegroundHovered: 'SystemBlue70',
    ButtonPrimaryToggleForegroundPressed: 'SystemBlue70',
    ButtonPrimaryToggleForegroundDisabled: 'SystemBlue30',
    ButtonPrimaryToggleBackgroundOff: 'SystemWhite',
    ButtonPrimaryToggleBackgroundOffHovered: 'SystemGrey0',
    ButtonPrimaryToggleBackgroundOffPressed: 'SystemGrey5',
    ButtonPrimaryToggleBackgroundOffDisabled: 'SystemWhite',
    ButtonPrimaryToggleBorderOff: 'SystemGrey10',
    ButtonPrimaryToggleBorderOffHovered: 'SystemGrey10',
    ButtonPrimaryToggleBorderOffPressed: 'SystemGrey10',
    ButtonPrimaryToggleBorderOffDisabled: 'SystemGrey0',
    ButtonPrimaryToggleForegroundOff: 'SystemBlack',
    ButtonPrimaryToggleForegroundOffHovered: 'SystemBlack',
    ButtonPrimaryToggleForegroundOffPressed: 'SystemBlack',
    ButtonPrimaryToggleForegroundOffDisabled: 'SystemGrey30',
    ButtonSecondaryToggleBackground: 'SystemBlue5',
    ButtonSecondaryToggleBackgroundDisabled: 'SystemBlue0',
    ButtonSecondaryToggleBackgroundHovered: 'SystemBlue10',
    ButtonSecondaryToggleBackgroundPressed: 'SystemBlue20',
    ButtonSecondaryToggleBorder: 'SystemBlue40',
    ButtonSecondaryToggleBorderDisabled: 'SystemBlue10',
    ButtonSecondaryToggleBorderHovered: 'SystemBlue40',
    ButtonSecondaryToggleBorderPressed: 'SystemBlue40',
    ButtonSecondaryToggleForeground: 'SystemBlue70',
    ButtonSecondaryToggleForegroundDisabled: 'SystemGrey30',
    ButtonSecondaryToggleForegroundHovered: 'SystemBlue70',
    ButtonSecondaryToggleForegroundPressed: 'SystemBlue70',
    ButtonSecondaryToggleBackgroundOff: 'SystemWhite',
    ButtonSecondaryToggleBackgroundOffDisabled: 'SystemWhite',
    ButtonSecondaryToggleBackgroundOffHovered: 'SystemGrey0',
    ButtonSecondaryToggleBackgroundOffPressed: 'SystemGrey5',
    ButtonSecondaryToggleBorderOff: 'SystemGrey5',
    ButtonSecondaryToggleBorderOffDisabled: 'SystemGrey0',
    ButtonSecondaryToggleBorderOffHovered: 'SystemGrey10',
    ButtonSecondaryToggleBorderOffPressed: 'SystemGrey10',
    ButtonSecondaryToggleForegroundOff: 'SystemBlack',
    ButtonSecondaryToggleForegroundOffDisabled: 'SystemGrey30',
    ButtonSecondaryToggleForegroundOffHovered: 'SystemBlack',
    ButtonSecondaryToggleForegroundOffPressed: 'SystemBlack',
    ButtonTertiaryBackground: 'SystemGrey5',
    ButtonTertiaryBackgroundHovered: 'SystemGrey20',
    ButtonTertiaryBackgroundPressed: 'SystemGrey20',
    ButtonTertiaryForeground: 'SystemBlack',
    ButtonTertiaryToggleBackground: 'SystemBlack',
    ButtonTertiaryToggleBackgroundHovered: 'SystemGrey70',
    ButtonTertiaryToggleBackgroundPressed: 'SystemGrey80',
    ButtonTertiaryToggleBackgroundDisabled: 'SystemGrey10',
    ButtonTertiaryToggleBorder: 'SystemBlack',
    ButtonTertiaryToggleBorderHovered: 'SystemGrey70',
    ButtonTertiaryToggleBorderPressed: 'SystemGrey80',
    ButtonTertiaryToggleBorderDisabled: 'SystemGrey10',
    ButtonTertiaryToggleForeground: 'SystemWhite',
    ButtonTertiaryToggleForegroundHovered: 'SystemWhite',
    ButtonTertiaryToggleForegroundPressed: 'SystemWhite',
    ButtonTertiaryToggleForegroundDisabled: 'SystemGrey40',
    ButtonTertiaryToggleBackgroundOff: 'SystemWhite',
    ButtonTertiaryToggleBackgroundOffHovered: 'SystemGrey10',
    ButtonTertiaryToggleBackgroundOffPressed: 'SystemGrey5',
    ButtonTertiaryToggleBackgroundOffDisabled: 'SystemGrey0',
    ButtonTertiaryToggleBorderOff: 'SystemBlack',
    ButtonTertiaryToggleBorderOffHovered: 'SystemGrey70',
    ButtonTertiaryToggleBorderOffPressed: 'SystemGrey80',
    ButtonTertiaryToggleBorderOffDisabled: 'SystemGrey30',
    ButtonTertiaryToggleForegroundOff: 'SystemBlack',
    ButtonTertiaryToggleForegroundOffHovered: 'SystemBlack',
    ButtonTertiaryToggleForegroundOffPressed: 'SystemBlack',
    ButtonTertiaryToggleForegroundOffDisabled: 'SystemGrey30',
    ListCellIconToggledOn: 'SystemBlue60',
    LoadingDefault: 'SystemBlue60',
    PaginationNumberedSelectedBackground: 'SystemBlue5',
    PaginationNumberedSelectedBackgroundDisabled: 'SystemBlue0',
    PaginationNumberedSelectedBackgroundHovered: 'SystemBlue10',
    PaginationNumberedSelectedBackgroundPressed: 'SystemBlue20',
    PaginationNumberedSelectedBorder: 'SystemBlue40',
    PaginationNumberedSelectedBorderDisabled: 'SystemBlue10',
    PaginationNumberedSelectedBorderHovered: 'SystemBlue40',
    PaginationNumberedSelectedBorderPressed: 'SystemBlue40',
    PaginationNumberedSelectedForeground: 'SystemBlue70',
    PaginationNumberedSelectedForegroundDisabled: 'SystemGrey30',
    PaginationNumberedSelectedForegroundHovered: 'SystemBlue70',
    PaginationNumberedSelectedForegroundPressed: 'SystemBlue70',
    PaginationNumberedUnselectedBackground: 'SystemWhite',
    PaginationNumberedUnselectedBackgroundDisabled: 'SystemWhite',
    PaginationNumberedUnselectedBackgroundHovered: 'SystemGrey0',
    PaginationNumberedUnselectedBackgroundPressed: 'SystemGrey5',
    PaginationNumberedUnselectedBorder: 'SystemGrey5',
    PaginationNumberedUnselectedBorderDisabled: 'SystemGrey0',
    PaginationNumberedUnselectedBorderHovered: 'SystemGrey10',
    PaginationNumberedUnselectedBorderPressed: 'SystemGrey10',
    PaginationNumberedUnselectedForeground: 'SystemBlack',
    PaginationNumberedUnselectedForegroundDisabled: 'SystemGrey30',
    PaginationNumberedUnselectedForegroundHovered: 'SystemBlack',
    PaginationNumberedUnselectedForegroundPressed: 'SystemBlack',
    OverlayLoadingDefault: 'SystemBlue60',
    PaginationSelectedPrimary: 'SystemBlue60',
    RatingSelected: 'SystemBlue60',
    SliderKnobBackground: 'SystemBlue60',
    SliderKnobBackgroundHovered: 'SystemBlue70',
    SliderKnobBackgroundPressed: 'SystemBlue80',
    SliderTrackBackgroundOn: 'SystemBlue60',
    TagHighlightBackground: 'SystemBlue60',
    TextAction: 'SystemBlue60',
    TextCallout: 'SystemBlue60',
    TextHighlight: 'SystemBlue60',
    TextSelected: 'SystemBlue60',
    TagHighlightDefaultBackground: 'SystemBlue10',
    TagHighlightDefaultForeground: 'SystemBlue70',
    TagHighlightDefaultIcon: 'SystemBlue70',
    TagHighlightEmphasisBackground: 'SystemBlue60',
    TagHighlightEmphasisForeground: 'SystemWhite',
    TagHighlightEmphasisIco: 'SystemWhite',
    ToggleBackgroundOn: 'SystemBlue60',
    ToggleBorderOn: 'SystemBlue60',
    TooltipHighlightBackground: 'SystemBlue60',
    TooltipHighlightBackgroundHovered: 'SystemBlue70',
    TooltipHighlightBackgroundPressed: 'SystemBlue80'
  }
};